<!--
 @description view列表 组件
 @author huangzhijie
 @date 2018/11/19
-->
<style>

</style>

<template>
  <div style="margin-bottom: 16px;">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item >
        <el-input v-model="form.name" prefix-icon="uk-icon-search" :placeholder="$t('common.search')"></el-input>
      </el-form-item>
      <slot name="header"></slot>
    </el-form>      

    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="control" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
  </div>
</template>
<script>

import dic from '@/components/mixins/dic'
import table from '@/components/mixins/table'
import ViewBiz from '@/logic/intelligentMonitor/viewBiz'
import { debounce, extend } from '@/utils/tool'

export default {
  mixins: [dic, table],
  components: {
  },
  data () {
    const that = this
    return {
      inputTimer: null,
      doSearch: debounce(that.search, 500), // this is a curry function
      form: {
        name: ''
      }
    }
  },
  props: {
    control: {
      require: true,
      type: Array
    }
  },
  watch: {
    'form.name' (val) {
      this.doSearch(val)
    },
    $route (to, from) {
      if (to.name === 'view' && from.name === 'viewConfig') {
        this.form.name = ''
      } else if (to.name === 'handlerDashBoard' && from.name === 'dashBoard') {
        this.form.name = ''
      }
    }
  },
  methods: {
    init () {

    },
    initTable () {
      this.tInitTable({
        lanKey: 'view.table',
        head: ['name', 'type'],
        requestFun: this.search
      })
    },
    search (data) {
      const reqData = extend(true, data, this.form)
      ViewBiz.findView(reqData).then((d) => {
        this.tData = d
      })
    },
    e_config () {
      this.$router.push({ name: 'viewChartSelect' })
    },
    e_goDetail (row, $index, data) {
      // console.log($index, row)
      const query = {
        appName: row.extend.appName,
        group: row.extend.group,
        kpiKey: row.extend.kpiKey,
        viewId: row.id,
        type: row.type,
        dName: row.extend.name
      }
      if (row.param.series && typeof row.param.series === 'string') {
        query.series = row.param.series
      }
      this.$router.push({
        name: 'viewConfig',
        query
      })
    },
    e_delete (row, index, data) {
      this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
        type: 'warning'
      }).then(() => {
        ViewBiz.deleteView({
          id: [row.id]
        }).then((data) => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.search()
        })
      }).catch(() => {

      })
    }
  },
  mounted () {
    this.initTable()
    this.search()
  }
}
</script>
